export default "__VITE_ASSET__ff157279__"